export const handleDiceServerInput = (
  camerasObject: any,
  setCamerasObject: any,
  inputString: string
) => {
  // Update localStorage first so AutoAddTable doesn't overwrite our changes
  const diceAlertPostObject = JSON.parse(
    localStorage.diceAlertPostObject || "{}"
  );
  diceAlertPostObject.dice_server = inputString;
  localStorage.setItem(
    "diceAlertPostObject",
    JSON.stringify(diceAlertPostObject)
  );

  // Create a deep copy of the camerasObject to ensure React detects the change
  const newCamerasObject = { ...camerasObject };

  for (const key in camerasObject) {
    newCamerasObject[key] = {
      ...camerasObject[key],
      dice: {
        ...camerasObject[key].dice,
      },
    };
    newCamerasObject[key].dice.dice_server = inputString;
  }

  setCamerasObject(newCamerasObject);
};
